import { Label, RadioGroup, RadioGroupItem } from '@shared/components/shadcn';
import { FilterSectionTitle } from '../FilterSectionTitle/FilterSectionTitle';

type SortingSectionProps = {
  sectionTitle: string;
  value: string;
  options: { label: string; value: string; trackName?: string }[];
  onChange: (value: string) => void;
  className?: string;
};

function SortingSection({ options, value, sectionTitle, onChange, className }: SortingSectionProps) {
  return (
    <div className={className} data-track-container="Sorting" data-testid="sorting-section">
      <FilterSectionTitle title={sectionTitle} />
      <RadioGroup className="mt-4" onValueChange={onChange} value={value}>
        {options.map(radioItem => (
          <div
            className="flex items-center gap-3 hover:text-foreground-subtle"
            key={radioItem.value}
            data-track-name={radioItem.trackName}
            data-testid={radioItem.trackName ? `sort-option-${radioItem.trackName.toLowerCase()}` : undefined}
          >
            <RadioGroupItem className="size-7" value={radioItem.value} id={radioItem.value} />
            <Label className="paragraph-explanatory hover:text-inherit" htmlFor={radioItem.value}>
              {radioItem.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
}

export { SortingSection };
